var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.sheet
    ? _c(
        "div",
        {
          staticClass: "text-center persistent_bottom",
          class: [_vm.sheet ? "animated fadeInUp" : ""],
          attrs: { "data-wow-delay": "0.6s" },
          model: {
            value: _vm.sheet,
            callback: function ($$v) {
              _vm.sheet = $$v
            },
            expression: "sheet",
          },
        },
        [
          _c("v-modal-contents", {
            ref: "modal_contents_policy",
            scopedSlots: _vm._u(
              [
                {
                  key: "close",
                  fn: function () {
                    return [_c("div")]
                  },
                  proxy: true,
                },
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "terms_of_use__title  " }, [
                        _c("div", { staticClass: "h2_title" }, [
                          _vm._v(
                            "Согласие на обработку персональных данных\n                    в целях сбора и ведения статистики\n                "
                          ),
                        ]),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "terms_of_use mt-30 " }, [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.agrstat) },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-30" }, [
                          _c(
                            "button",
                            {
                              staticClass: "px-30 btn-red",
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.modal_contents_policy.modal_open()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        Прочитал\n                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3302614878
            ),
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "persistent_bottom__wrapper d-flex align-center" },
            [
              _c("div", { staticClass: "py-3 " }, [
                _vm._v(
                  "\n\n            Для улучшения работы сайта ООО «Компания Нова Ролл» может собирать данные, используя файлы\n            "
                ),
                _c("a", { attrs: { href: _vm.cookie, target: "_blank" } }, [
                  _vm._v("cookie"),
                ]),
                _vm._v(
                  "\n            и сервис «Яндекс Метрика». Это соответствует\n            "
                ),
                _c("a", { attrs: { href: _vm.policy, target: "_blank" } }, [
                  _vm._v("Политике конфиденциальности"),
                ]),
                _vm._v(
                  ".\n            Нажимая кнопку «Принять» вы даете\n            "
                ),
                _c(
                  "a",
                  {
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.modal_contents_policy.modal_open(
                          "scroll_false"
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                согласие на обработку персональных данных\n            "
                    ),
                  ]
                ),
                _vm._v(".\n\n        "),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "btn_bordered persistent_bottom__btn",
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.sheetClose()
                    },
                  },
                },
                [_vm._v("\n            Принять\n        ")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }